<template>
    <div class="container">
        <typo v-if="legend" class="legend" name="body-10-normal">
            {{ legend }}
        </typo>
        <router-link :to="link">
            <div class="title-info">
                <typo name="body-14-normal">{{ convention.shortTitle }}</typo>
            </div>
        </router-link>
        <div class="numbers-info">
            <typo v-if="convention.brochure" name="body-12-light">
                Numéro de brochure : {{ convention.brochure }}
            </typo>
            <typo v-if="convention.idcc" name="body-12-light">IDCC : {{ convention.idcc }}</typo>
            <typo v-if="convention.type" name="body-12-light">
                Type : {{ conventionTypes[convention.type] }}
            </typo>
        </div>
    </div>
</template>

<script>
import { getLegendText } from "src/utils/convention";

export default {
    components: {},
    props: ["convention", "isChild"],
    computed: {
        conventionTypes() {
            return this.$privateDico.convention.type;
        },
        legend() {
            return getLegendText(this.convention, this.isChild);
        },
        link() {
            return `/espace-client/conventions-collectives/${this.convention.conventionId}/${this.convention.variantNumber}/obligations`;
        },
    },
};
</script>

<style scoped lang="sass">
.title-info
    border-bottom: 1px solid $color-grey
    padding-bottom: 5px
    padding-right: 20px
    color: black
    &:hover
        text-decoration: underline
.numbers-info
    padding-top: 10px
    display: flex
    flex-direction: column
</style>
